import { SortDirection } from '@/utils/types';

type Args<T> = {
	items: T[];
	search: string;
	page: string;
	limit: string;
	sortBy: keyof T;
	sortDirection: SortDirection;
	filterPredicate: (item: T, search: string) => boolean;
};

export const getPaginatedItems = <T>(args: Args<T>) => {
	const { items, search, page, limit, sortBy, sortDirection, filterPredicate } = args;

	const pageParam = parseInt(page);
	const limitParam = parseInt(limit);

	const filteredItems = items.filter((item: T) => {
		const searchParam = search.toLowerCase().trim();
		if (!searchParam) return true;

		return filterPredicate(item, searchParam);
	});

	const sortedItems = filteredItems.sort((a: T, b: T) => {
		const aValue = a[sortBy];
		const bValue = b[sortBy];

		if (typeof aValue === 'number' && typeof bValue === 'number') {
			return sortDirection === SortDirection.ASC ? aValue - bValue : bValue - aValue;
		}

		const aStr = aValue ? aValue.toString() : '';
		const bStr = bValue ? bValue.toString() : '';
		return sortDirection === SortDirection.ASC ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
	});

	const totalPages = sortedItems.length <= limitParam ? 1 : Math.ceil(sortedItems.length / limitParam);
	const start = (pageParam - 1) * limitParam;
	const paginatedItems = sortedItems.slice(start, start + limitParam);

	return {
		paginatedItems,
		totalPages
	};
};
